/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoginAttemptResultEnum {
    SUCCESS = 'Success',
    FAILURE = 'Failure',
    DENIED = 'Denied',
}